import { useState } from "react";
import PropTypes from "prop-types";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "../../../../components/MDBox";
import MDTypography from "../../../../components/MDTypography";
import MDButton from "../../../../components/MDButton";
import MDSnackbar from "../../../../components/MDSnackbar";

// Settings page components
import FormField from "../FormField";
import authorService from "../../../../services/authorService";

function BasicInfo({ userData, setUserData }) {
  const [notification, setNotification] = useState({
    open: false,
    color: "info",
    title: "",
    content: "",
  });

  const closeNotification = () => setNotification({ ...notification, open: false });

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name.includes(".")) {
      const [parent, child] = name.split(".");
      setUserData((prev) => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value,
        },
      }));
    } else {
      setUserData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleChangeProfile = async (event) => {
    event.preventDefault();
    
    try {
      await authorService.update(userData._id, userData);
      setNotification({
        open: true,
        color: "success",
        title: "Éxito",
        content: "Información actualizada correctamente",
      });
    } catch (err) {
      console.error(err);
      setNotification({
        open: true,
        color: "error",
        title: "Error",
        content: "No se pudo actualizar la información",
      });
    }
  };

  return (
    <Card id="basic-info" sx={{ overflow: "visible" }}>
      <MDBox p={3}>
        <MDTypography variant="h5">Información básica</MDTypography>
      </MDBox>
      <MDBox component="form" pb={3} px={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <FormField
              label="Usuario (No editable)"
              name="username"
              value={userData.username}
              inputProps={{ readOnly: true, disabled: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              label="Email"
              placeholder="example@email.com"
              inputProps={{ type: "email" }}
              name="email"
              value={userData.email}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              label="Nombre"
              placeholder="Nombre"
              name="name"
              value={userData.name}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              label="Apellidos"
              placeholder="Apellidos"
              name="last_name"
              value={userData.last_name}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <FormField
              label="Biografía"
              placeholder="Cuéntanos sobre ti..."
              name="bio"
              value={userData.bio}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              label="Sitio Web"
              placeholder="https://su-web.com"
              name="social_media.website"
              value={userData.social_media.website}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              label="Twitter"
              placeholder="@usuario"
              name="social_media.twitter"
              value={userData.social_media.twitter}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              label="Facebook"
              placeholder="su-perfil"
              name="social_media.facebook"
              value={userData.social_media.facebook}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              label="Instagram"
              placeholder="@usuario"
              name="social_media.instagram"
              value={userData.social_media.instagram}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              label="LinkedIn"
              placeholder="perfil-profesional"
              name="social_media.linkedin"
              value={userData.social_media.linkedin}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems="flex-end"
          flexWrap="wrap"
          mt={3}
        >
          <MDBox ml="auto">
            <MDButton
              variant="gradient"
              color="info"
              size="small"
              onClick={handleChangeProfile}
            >
              Guardar
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
      <MDSnackbar
        color={notification.color}
        icon={notification.color === "error" ? "warning" : "check"}
        title={notification.title}
        content={notification.content}
        dateTime="Ahora"
        open={notification.open}
        onClose={closeNotification}
        close={closeNotification}
        bgWhite
      />
    </Card>
  );
}

BasicInfo.propTypes = {
  userData: PropTypes.object,
  setUserData: PropTypes.func.isRequired,
};

export default BasicInfo;
